module.exports = __webpack_public_path__ + "img/environment-tishi.24daa785.png";